import { useI18n } from '@mssgme/i18n';

export const useUITranslations = () => {
    return useI18n('ui', (language) =>
        import(
            /* webpackChunkName: "locales.ui" */
            /* webpackInclude: /\.json$/ */
            `../../locales/${language}/ui.json`
        )
    );
};
